
  


  <template>
    <b-container>
      <!-- Date Range Section -->
      <b-card class="mb-4">
        <b-row align-v="center">
          <b-col cols="12" md="6" lg="4">
            <label class="mb-2 font-weight-bold">Select Date Range to View Reports</label>
            <DatePicker 
              v-model="dateRange" 
              range 
              format="YYYY-MM-DD" 
              placeholder="Select date range"
              @change="handleDateRangeChange" 
              size="sm" 
              style="width: 100%;"
            />
          </b-col>
          <b-col cols="12" md="6" lg="4" class="mt-3 mt-md-0">
            <b-button 
              variant="primary" 
              :disabled="!dateRange" 
              @click="handleDateRangeChange"
              class="ml-md-2"
            >
              Refresh Reports
            </b-button>
          </b-col>
        </b-row>
      </b-card>
  
      <!-- Loading State -->
      <div class="d-flex justify-content-center mb-4" v-if="loading || reportLoading">
        <b-spinner variant="primary" label="Loading reports..." style="width: 3rem; height: 3rem"></b-spinner>
        <p class="ml-3 mb-0 align-self-center">Loading reports...</p>
      </div>
  
      <!-- No Date Range Selected State -->
      <b-alert show variant="info" v-if="!dateRange && !loading && !reportLoading">
        Please select a date range above to view the reports.
      </b-alert>
  
      <!-- Reports Section -->
      <b-row v-if="dateRange && !loading && !reportLoading">
        <b-col cols="12">
          <Ticketingchart :data="ticketCategoryReport" />
        </b-col>
        <b-col cols="12">
          <Ass :data="complainResolutionTimeReport" />
        </b-col>
        <b-col cols="12">
          <StaffChart :data="staffComplaintHandlingPerformance" />
        </b-col>
        <b-col cols="12">
          <Complaint :data="customerComplaintFrequency" />
        </b-col>
        <b-col cols="12">
          <LeadClientOpportunityChart :data="leadClientOpportunityCostSummary" />
        </b-col>
        <b-col cols="12">
          <CustomerTicketVolumeChart :data="customerTicketVolumeAnalysis" />
        </b-col>
        <b-col cols="12">
          <MoreAnalytics1 :data="salesSummaryReport" />
        </b-col>
        <b-col cols="12">
          <MoreAnalytics2 :data="salesAnalyticsReport" />
        </b-col>
        <b-col cols="12">
          <MoreAnalytics3 :data="salesAnalyticsReportByClient" />
        </b-col>
        <b-col cols="12">
          <MoreAnalytics4 :data="salesAnalyticsReportByProduct" />
        </b-col>
        <b-col cols="12">
          <QuotationPriorityChart :data="quotationPriorityReport" />
        </b-col>
        <b-col cols="12">
          <ContributionBarChart :data="SalesValueContributionBySalesperson" />
        </b-col>
        <b-col cols="12">
          <LeadAgingBarChart :data="LeadAgingAnalysis" />
        </b-col>
        <b-col cols="12">
          <ChartSales :sales="salesOrderList" :totalSales="totalSalesAmount" />
        </b-col>
        <!-- <b-col cols="12">
          <SalesTable :sales="salesOrderList" />
        </b-col> -->
      </b-row>
    </b-container>
  </template>
  
  
  <script>
  
   import Salesperformancedatapercustomer from "./Salesperformancedatapercustomer.vue";
   import MoreAnalytics4 from "./moreAnalytics4.vue";
  import MoreAnalytics3 from "./moreAnalytics3.vue";
   import MoreAnalytics2 from "./moreAnalytics2.vue";
   import MoreAnalytics1 from "./moreAnalytics1.vue";
  import Ticketingchart from "./Ticketingchart.vue";
   import Ass from "./a.vue";
  import StaffChart from "./StaffChart.vue";
  import Complaint from "./Complaint.vue";
  import QuotationBarChart from "./QuotationBarChart.vue";
  import QuotationPriorityChart from "./QuotationPriorityChart.vue";
  import ContributionBarChart from "./ContributionBarChart.vue";
  import LeadAgingBarChart from "./LeadAgingBarChart.vue";
  import ChartSales from "./ChartSales.vue";
  import SalesTable from "./SalesTable.vue";
  import LeadClientOpportunityChart from "./LeadClientOpportunityChart.vue"
  import CustomerTicketVolumeChart from "./CustomerTicketVolumeChart.vue";
  import { BContainer, BRow, BCol, BSpinner,  BButton } from "bootstrap-vue";
  import { mapActions, mapGetters } from "vuex";
  import DatePicker from "vue2-datepicker";
  import "vue2-datepicker/index.css";
import SalesOverTimeChart from "./SalesOverTimeChart.vue";
import { groupBy } from "lodash";
  
  export default {
    components: {
      DatePicker,
      BContainer,
      BRow,
      SalesTable,
      ChartSales,
      BCol,
      BSpinner,
      Salesperformancedatapercustomer,
      LeadAgingBarChart,
      QuotationPriorityChart,
      ContributionBarChart,
      QuotationBarChart,
      Complaint,
      StaffChart,
      SalesOverTimeChart,
      Ass,
      BButton,
      MoreAnalytics1,
      MoreAnalytics2,
      MoreAnalytics3,
      MoreAnalytics4,
      Ticketingchart,
      LeadClientOpportunityChart,
      CustomerTicketVolumeChart,
    },
  
    data() {
      const today = new Date();
      return {
        totalSalesAmount: 0,
       dateRange: [today, today],
        isInitialLoad: true
      };
    },
    computed: {
      ...mapGetters("salesOrderModule", {
        salesOrderList: "salesorders",
        loading: "loading",
      }),
      ...mapGetters("reportModule", {
        complainResolutionTimeReport: "complaintResolutionTime",
        staffComplaintHandlingPerformance: "staffComplaintHandlingPerformance",
        customerComplaintFrequency: "customerComplaintFrequency",
        leadClientOpportunityCostSummary: "leadClientOpportunityCostSummary",
        customerTicketVolumeAnalysis: "customerTicketVolumeAnalysis",
        salesSummaryReport: "salesSummaryReport",
        SalesValueContributionBySalesperson: "SalesValueContributionBySalesperson",
        LeadAgingAnalysis: "LeadAgingAnalysis",
        salesAnalyticsReport: "salesAnalyticsReport",
        salesAnalyticsReportByClient: "salesAnalyticsReportByClient",
        salesAnalyticsReportByProduct: "salesAnalyticsReportByProduct",
        ticketCategoryReport: "ticketCategoryReport",
        quotationPriorityReport: "quotationPriorityReport",
        reportLoading: "loading"
      }),
    },
  
    methods: {
      ...mapActions("salesOrderModule", [
        "getSalesOrdersListAction",
      ]),
      ...mapActions("reportModule", [
        "getComplaintResolutionTimeReportAction",
        "getStaffComplaintHandlingPerformanceAction",
        "getCustomerComplaintFrequencyAction",
        "getLeadClientOpportunityCostSummaryAction",
        "getCustomerTicketVolumeAnalysisAction",
        "getSalesSummaryReportAction",
        "getSalesValueContributionBySalespersonAction",
        "getLeadAgingAnalysisAction",
        "getSalesAnalyticsReportAction",
        "getSalesAnalyticsReportByClientAction",
        "getSalesAnalyticsReportByProductAction",
        "getTicketCategoryReportAction",
        "getQuotationPriorityReportAction",
      ]),

      async handleDateRangeChange() {
      if (!this.dateRange || !this.dateRange[0] || !this.dateRange[1]) {
        return;
      }

      const dateParams = {
        dateFrom: this.formatDate(this.dateRange[0]),
        dateTo: this.formatDate(this.dateRange[1]),
      };

      try {
        await this.fetchAllReports(dateParams);
      } catch (error) {
        console.error("Error updating reports:", error);
      }
    },

    async fetchAllReports(dateParams, queryStringObj) {
      try {
        await Promise.all([
          this.getSalesOrdersListAction(),
          this.fetchComplaintData(dateParams),
          this.fetchStaffComplaintHandlingPerformance(dateParams),
          this.getCustomerComplaintFrequencyAction(dateParams),
          this.getLeadClientOpportunityCostSummaryAction(dateParams),
          this.getCustomerTicketVolumeAnalysisAction(dateParams),
          this.getSalesValueContributionBySalespersonAction(dateParams),
          this.getLeadAgingAnalysisAction(dateParams),
          this.getSalesSummaryReportAction(queryStringObj),
          this.getSalesAnalyticsReportAction(dateParams),
          this.getSalesAnalyticsReportByClientAction(dateParams),
          this.getSalesAnalyticsReportByProductAction(dateParams),
          this.getTicketCategoryReportAction(dateParams),
          this.getQuotationPriorityReportAction(dateParams),
        ]);

        // Update total sales amount after fetching new data
        this.updateTotalSalesAmount();
      } catch (error) {
        console.error('Error fetching reports:', error);
        // You might want to add error handling UI here
      }
    },


    formatDate(date) {
      return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
    },

    updateTotalSalesAmount() {
      this.totalSalesAmount = this.salesOrderList.reduce((total, order) => total + order.total, 0);
    },

      async fetchComplaintData(dateParams) {
        console.log('Starting to fetch complaint data');
        try {
          await this.getComplaintResolutionTimeReportAction(dateParams);
          // console.log('API call completed');
          // console.log('Data:', this.complainResolutionTimeReport);
        } catch (error) {
          console.error('Error in fetchComplaintData:', error);
        }
      },

      async fetchStaffComplaintHandlingPerformance(dateParams) {
        try {
          await this.getStaffComplaintHandlingPerformanceAction(dateParams);

        } catch (error) {
          console.error('Error in staffComplaintHandlingPerformance:', error);
        }
      }
    },
  
    async mounted() {

      await this.handleDateRangeChange();

      await this.getSalesOrdersListAction()
        .then(() => {
          let totalSalesAmount = 0;
          this.salesOrderList.forEach(order => {
            totalSalesAmount += order.total;
          });
          this.totalSalesAmount = totalSalesAmount;
        })
        .catch((response) => {
          console.log(response);
        });

        // await this.fetchComplaintData();
        // await this.fetchStaffComplaintHandlingPerformance();
        // await this.getCustomerComplaintFrequencyAction();
        // await this.getLeadClientOpportunityCostSummaryAction();
        // await this.getCustomerTicketVolumeAnalysisAction();
    },
  };
  </script>


  